import Template from "../Pumpkin.ejs";
import Events from "../../Utils/EventLite";
import Element from "../../Utils/Element";
import {CONFIG} from "../../config";

export default class PumpkinResult extends Element {
    constructor(data) {
        super();
        this.data = data;
        this.element = document.createElement("li");
        this.element.classList.add("PumpkinResult");
        if(localStorage.getItem("vote"+CONFIG.year) === data.key) {
            this.element.classList.add("selected");
        }
        this.element.classList.add(data.key);
        this.element.innerHTML = Template(data); 
        this.clicked = this.select.bind(this);
        this.element.addEventListener("click", this.clicked);
    }

    select(e) {
        Events.trigger("showOverlay", this.data);
    }

    destroy () {
        this.element.removeEventListener("click", this.clicked);
        super.destroy();
    }

}


// WEBPACK FOOTER //
// ./src/views/Components/PumpkinResult.js